<template>
    <div>
        <div>
            <label class="full">Country</label>

            <vSelect
                v-if="selectedCountry"
                label="name"
                v-model="selectedCountry"
                placeholder="Pick a country"
                :options="getCountries"
                @input="updateCountry">
            </vSelect>
        </div>

        <!-- <div class="row form-group">
            <div class="col-sm-8">
                <label class="full">Timezone</label>

                <vSelect
                    label="text"
                    v-model="selectedTimezone"
                    placeholder="Pick a timezone"
                    :options="getTimezones"
                    @input="updateTimezone">
                </vSelect>
            </div>

            <div class="col-sm-4">
                <label class="full">Currency</label>

                <vSelect
                    label="code"
                    v-model="selectedCurrency"
                    placeholder="Pick a currency"
                    :options="currencies"
                    @input="updateCurrency">
                </vSelect>
            </div>
        </div> -->
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        data: function() {
            return {
                form: [],
                defaultCountryId: 176,
                selectedCountry: null,
                selectedTimezone: "(UTC) Dublin, Edinburgh, Lisbon, London",
                selectedCurrency: "EUR",
            }
        },
        created: function() {
            this.setDefaultCountry()
        },
        computed: {
            ...mapGetters([
                'getCountries',
                'getCurrencies',
                'getTimezones',
            ]),
            currencies: function() {
                return Object.keys(this.getCurrencies).map(key => {
                    return this.getCurrencies[key];
                });
            }
        },
        methods: {
            setDefaultCountry: function() {
                this.getCountries.map(country => {
                    // console.log(country.id);
                    if(country.id == this.defaultCountryId){
                        this.selectedCountry = country
                        console.log(country);
                    }
                })
            },
            updateCountry: function() {
                this.form.country = this.selectedCountry.id || null;
                this.emitFields();
            },
            updateTimezone: function() {
                this.form.timezone = this.selectedTimezone.text || null;
                this.emitFields();
            },
            updateCurrency: function() {
                this.form.currency = this.selectedCurrency.code || null;
                this.emitFields();
            },
            emitFields: function() {
                this.$emit('locationFieldsChanged', {
                    'country': this.form.country,
                    'timezone': this.form.timezone,
                    'currency': this.form.currency,
                });
            }
        },
        components: {
            vSelect: extendedVSelect,
        }
    }
</script>



// WEBPACK FOOTER //
// LocationFields.vue?b61a6c82